import { HeaderLogo, HeaderTitle } from '@doda/io-react/pc';
import { DEFAULT_LEAD_SENTENCE } from 'constants/headerLeadSentence';
import { FC } from 'react';
import { Register } from '@doda/io-react/common';
import { headerMemberRegistrationButtonGroupNoSelector } from '@doda/common/src/redux/features/abTest';
import { VisibleAnalytics } from '@doda/common/src/components/Analytics/VisibleAnalytics';
import styles from './index.module.scss';
import {
  JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_AB_TEST_GROUP_NO,
  JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_URL,
} from '../../constants';
import {
  measureHeaderRegistrationButtonClick,
  measureVisibleHeaderRegistrationButton,
} from '../../logics/analytics';
import { useAppSelector } from '../../../../../../redux/hooks';

/** JobSearchDetailHeaderProps */
interface Props {
  isLoggedIn: boolean;
}

/**
 * PC)求人詳細 ヘッダー内登録ボタン表示ABテスト用ヘッダー
 */
export const JobSearchDetailHeader: FC<Props> = ({ isLoggedIn }) => {
  const abTestGroupNo =
    useAppSelector(headerMemberRegistrationButtonGroupNoSelector) ?? '0';
  return (
    <VisibleAnalytics
      onVisible={() => measureVisibleHeaderRegistrationButton(abTestGroupNo)}
    >
      <header className={styles.jobSearchDetailHeader}>
        <div className={styles.jobSearchDetailHeader__inner}>
          <div className={styles.jobSearchDetailHeader__logo}>
            <HeaderLogo
              imgUrl="https://doda.jp/cmn_web/img/logo_doda/logo_slogan_bg_195x52_endorse.png"
              alt="はたらく今日が、いい日に。"
              href="/"
            />
            <HeaderTitle title={DEFAULT_LEAD_SENTENCE} as="p" />
            {abTestGroupNo ===
              JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_AB_TEST_GROUP_NO && (
              <div
                className={
                  styles.jobSearchDetailHeader__labeledIconMenu__wrapper
                }
              >
                {!isLoggedIn && (
                  <a
                    href={
                      JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_URL
                    }
                    onClick={() => {
                      measureHeaderRegistrationButtonClick();
                    }}
                  >
                    <button
                      type="button"
                      key="会員登録"
                      className={
                        styles.jobSearchDetailHeader__registerIcon__wrapper
                      }
                    >
                      <div
                        className={styles.jobSearchDetailHeader__iconWrapper}
                      >
                        <Register size="XL" color="white" />
                      </div>
                      <div
                        className={styles.jobSearchDetailHeader__icon__label}
                      >
                        会員登録
                      </div>
                    </button>
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </header>
    </VisibleAnalytics>
  );
};
